import { useState, useEffect } from "react";

export default function FloatingCall() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-8 right-6 z-50 flex flex-col items-end gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10 pointer-events-none"
      }`}
    >
      {/* Kakao Talk */}
      <a
        href="tel:010-2684-4892"
        className="flex items-center gap-2 bg-zinc-800 text-white text-sm font-semibold px-4 py-3 rounded-full shadow-lg hover:bg-zinc-700 transition-all cursor-pointer whitespace-nowrap"
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-message-2-fill text-blue-400 text-base" />
        </span>
        무료상담 문의
      </a>

      {/* Main Call Button */}
      <a
        href="tel:010-2684-4892"
        className="flex items-center gap-3 bg-blue-500 hover:bg-blue-400 text-white font-bold px-6 py-4 rounded-full shadow-xl transition-all duration-200 cursor-pointer whitespace-nowrap animate-bounce"
        style={{ animationDuration: "2s" }}
      >
        <span className="w-6 h-6 flex items-center justify-center">
          <i className="ri-phone-fill text-xl" />
        </span>
        <div className="flex flex-col leading-tight">
          <span className="text-xs font-normal opacity-90">24시 즉시출동</span>
          <span className="text-base font-bold">010-2684-4892</span>
        </div>
      </a>
    </div>
  );
}
